<!--账户余额-->
<template>
	<div class="home-main">
		<div class="main_title">
			<span class="title-cn">伙伴试用情况表</span>
			<span class="title-en">/Partner Trial</span>
		</div>
		<div class="main-container">
			<!--专用币余额列表start-->
			<div class="accountBalance-main-list">
				<el-table :data="tabelData" style="width: 100%" stripe>
					<el-table-column width="40">
					</el-table-column>
					<el-table-column label="类型">
						<template slot-scope="scope">
							<span>{{ scope.row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="累计充值金额">
						<template slot-scope="scope">
							<!-- <span>{{ scope.row.fbi_price}}</span> -->
						</template>
					</el-table-column>
					<el-table-column label="累计消耗金额">
						<template slot-scope="scope">
							<!-- <span>{{ scope.row.balance}}</span> -->
						</template>
					</el-table-column>
					<el-table-column label="当前可用余额">
						<template slot-scope="scope">
							<span>{{ scope.row.balance}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<!--专用币余额列表end-->
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
				/*表格数据start*/
				universal: [{
					name: '',
					balance: '0.00',
					recharge: '0.00',
					expenditure: '0.00',
				}],
				tabelData: [{
					name: '通用币',
					standardPrice: '2000.00',
					balance: '0.00',
					recharge: '0.00',
					expenditure: '0.00',
				},
				// {
				// 	specialCurrency: 'C9开发版',
				// 	standardPrice: '2000.00',
				// 	specialBalance: '2000.00',
				// 	specialRecharge: '57800.00',
				// 	specialExpend: '57500.00',
				// },
				// {
				// 	specialCurrency: 'C9标准版',
				// 	standardPrice: '2000.00',
				// 	specialBalance: '2000.00',
				// 	specialRecharge: '57800.00',
				// 	specialExpend: '57500.00',
				// },
				// {
				// 	specialCurrency: 'C9高级版',
				// 	standardPrice: '2000.00',
				// 	specialBalance: '2000.00',
				// 	specialRecharge: '57800.00',
				// 	specialExpend: '57500.00',
				// }
				],
				/*表格数据end*/
			};
		},
		mounted(){
			this.loading = true
			this.$store.dispatch('user/userinfo')
			.then(() => {
				this.loading = false
				let data = [
					{name:"通用币",balance:this.$store.getters.userInfo.finance.point},
					{name:"FastBI产品专用币",balance:this.$store.getters.userInfo.finance.fbi_point}
				]
				this.tabelData = data
				//this.tabelData[1].fbi_price = this.$store.getters.userInfo.finance.fbi_price
			})
			.catch(() => {
				this.loading = false
			})
		},
		methods: {
			
		}
	};
</script>

<style>
.accountBalance-list-title{
	background-color: #dae0e6;
}
.list-title{
	line-height: 40px;
	margin-left: 33px;
}
.accountBalance-list-separate{
	height: 15px;
	background-color: #F3F3F6;
}
</style>


// WEBPACK FOOTER //
// src/components/system/partnerTrial.vue